import React from 'react';
import { __ } from '../../../utils/translation-service';
import {
    StyledArrowText,
    StyledComponentWrapper,
    StyledExclusivesInnerWrapper,
    StyledExclusivesOuterWrapper,
    StyledLabelledArrowWrapper,
} from './highlights.style';

interface IProps {
    headline: string;
    exclusives: React.ReactElement[];
}

export const Highlights = (props: IProps) => {
    if (!props.headline || !props.exclusives) return null;

    const exclusives = !!props.exclusives?.length && (
        <StyledExclusivesOuterWrapper>
            <StyledLabelledArrowWrapper>
                <StyledArrowText>{__('exclusiveToDreamlines')}</StyledArrowText>
            </StyledLabelledArrowWrapper>

            <StyledExclusivesInnerWrapper>{props.exclusives}</StyledExclusivesInnerWrapper>
        </StyledExclusivesOuterWrapper>
    );

    return <StyledComponentWrapper>{exclusives}</StyledComponentWrapper>;
};
